export const IMAGE_TYPE = ['image/jpeg', 'image/jpg']
export const IMAGE_SIZE = 5
export const IMAGE_TYPE_ERROR = 'step2.error.imagetype'
export const IMAGE_SIZE_ERROR = 'step2.error.imagesize'
